import React from "react";
import { withStyles, TextField,Paper } from "@material-ui/core";
import { compose } from "recompose";
import { SingleSearch } from "../../../lib/Map";
import Autocomplete from "react-autocomplete";
import Cancel from "@material-ui/icons/Cancel";
import InputAdornment from "@material-ui/core/InputAdornment";
import { debounce } from "lodash";
//Regular expression to check for valid coordinates input. this will use to check if value is coordinates or string
const regexExp =
  /^(-?[1-8]?\d(?:\.\d{1,18})?|90(?:\.0{1,18})?),(-?(?:1[0-7]|[1-9])?\d(?:\.\d{1,18})?|180(?:\.0{1,18})?)$/;

const styles = (theme) => ({
  menuList: {
    maxHeight: 150,
    overflowY: "auto",
    paddingBottom: 4,
    paddingTop: 4,
    "-webkit-overflow-scrolling": "touch",
    boxSizing: "border-box",
  },
  menuItem: {
    fontSize: theme.textFontSize,
    padding: "5px 10px",
    minHeight: "20px",
    color: theme.TextColor,
    width: "86%",
  },
  activeMenuItem: {
    backgroundColor: theme.HeaderSelectedText,
  },
  fieldRoot: {},
  marginNormal: { margin: 0, width: "100%" },
  label: {
    color: theme.TextColor,
    transform: "translate(14px, 14px) scale(1)",
    fontSize: theme.headerTextFontSize,
    opacity: 0.7,
  },
  notchedOutline: {},
  inputRoot: {
    // width: "100%",
    "& $notchedOutline, &:hover:not($inputFocused):not($inputDisabled):not($inputError) $notchedOutline":
      {
        borderColor: `${theme.iconColor}`,
      },
    "&$inputFocused $notchedOutline": {
      borderWidth: 1,
    },
  },
  inputFocused: {},
  inputDisabled: {},
  inputError: {},
  inputField: {
    padding: 12,
    fontSize: theme.textFontSize,
    color: theme.TextColor,
    height: "initial",
  },
  iconClass: {
    color: theme.iconColor,
    cursor: "pointer",
  },
  toggleContainer: {
    marginTop: 16,
    fontSize: theme.headerTextFontSize,
    color: theme.gridTextColor,
    display: "flex",
    alignItems: "center",
  },
  toggleLabel: {
    width: "50%",
    display: "inline-block",
  },
  paper: {
    position: "absolute",
    zIndex: 10,
    left: 0,
    right: 0,
    backgroundColor: theme.ModalBGColor,
    color: theme.TextColor,
  },
});

class GeocoderSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchAddress: null,
      locationSuggestion: [],
    };
    this.handleCall = debounce(this.handleCall, 300);
  }

  componentDidMount() {
    if (this.props.inputValue) {
      this.setInput(this.props.inputValue, true);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.inputValue !== prevProps.inputValue) {
      this.setInput(this.props.inputValue);
    }
  }
  handleCall = (value) => {
    this.searchAddress(encodeURIComponent(value));
  };
  searchAddress(value, updateOnlyAddress) {
    if (value) {
      SingleSearch(value).then((data) => {
        if (!data.Err) {
          if (regexExp.test(value)) {
            const Coords = updateOnlyAddress
              ? { Lat: this.props.originalLat, Lon: this.props.originalLng }
              : data.Locations[0]?.Coords;
            const location = {
              ...data.Locations[0],
              Coords,
            };
            this.selectChange(data.Locations[0].ShortString, location);
            this.setState({ locationSuggestion: [] });
          } else {
            this.setState({ locationSuggestion: data.Locations });
          }
        } else {
          this.setState({ locationSuggestion: [] });
        }
      });
    }
  }

  handleChange = (event) => {
    const value = event && event.target ? event.target.value : "";
    this.setState({
      searchAddress: value,
    });
    if (value && value.length > 2) {
      this.handleCall(value);
    } else {
      this.props?.onClear?.(value);
    }
  };

  setInput = (value, updateOnlyAddress = false) => {
    if (this.state.searchAddress !== value) {
      this.setState({
        searchAddress: value,
      });
      if (value && value.length > 2) {
        this.searchAddress(value, updateOnlyAddress);
      }
    }
  };

  clearField = () => {
    this.setState({
      searchAddress: "",
      locationSuggestion: [],
    });
    this.props.getLocationDetails(["", ""], "", "");
    this.props?.onClear?.();
  };

  selectChange = (e, item) => {
    this.setState({
      searchAddress: e,
    });
    this.props.getLocationDetails(
      [item.Coords.Lon, item.Coords.Lat],
      item.Address.Zip,
      item.ShortString,
      item.Address
    );
  };
  getTextFieldDefaultProps = (classes) => {
    return {
      id: "searchAddress",
      classes: {
        root: classes.fieldRoot,
        marginNormal: classes.marginNormal,
      },
      InputLabelProps: {
        classes: {
          root: classes.label,
        },
      },
      InputProps: {
        classes: {
          root: classes.inputRoot,
          input: classes.inputField,
          notchedOutline: classes.notchedOutline,
          focused: classes.inputFocused,
          disabled: classes.inputDisabled,
          error: classes.inputError,
        },
        endAdornment: this.getFieldIcon("searchAddress"),
      },
      margin: "normal",
      variant: "outlined",
      error: Boolean(this.props.error),
    };
  };
  getFieldIcon = (field) => {
    const { classes } = this.props;
    if ("searchAddress") {
      return (
        <InputAdornment>
          <Cancel
            onClick={this.clearField}
            classes={{ root: classes.iconClass }}
          />
        </InputAdornment>
      );
    }
    return null;
  };
  render() {
    const { classes } = this.props;
    const { searchAddress, locationSuggestion } = this.state;
    return (
      <Autocomplete
        inputProps={{
          id: "searchAddress",
          placeholder: "Search Address",
        }}
        wrapperStyle={{
          position: "relative",
          display: "inline-block",
          width: "100%",
        }}
        value={searchAddress}
        items={locationSuggestion}
        getItemValue={(item) => item.ShortString}
        onSelect={this.selectChange}
        onChange={this.handleChange}
        renderMenu={(children) =>
          children.length > 0 ? (
            <Paper
              square
              className={`customScroll ${classes.menuList} ${classes.paper}`}
            >
              {children}
            </Paper>
          ) : (
            <div></div>
          )
        }
        renderInput={(props) => {
          const { ref, ...rest } = props;
          return (
            <TextField
              {...rest}
              inputRef={ref}
              {...this.getTextFieldDefaultProps(classes)}
              label="Search Address"
              value={searchAddress || ""}
            />
          );
        }}
        renderItem={(item, isHighlighted) => (
          <div
            className={`${classes.menuItem} ${
              isHighlighted && classes.activeMenuItem
            }`}
            key={item.ShortString}
          >
            {item.ShortString}
          </div>
        )}
      />
    );
  }
}

export default compose(withStyles(styles))(GeocoderSearch);
